import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { initClarity } from "./utils/clarity";
import "./index.css";

// Patch ResizeObserver globally so all callbacks are deferred via rAF,
// preventing the "loop completed with undelivered notifications" error on first mount.
if (typeof window.ResizeObserver !== "undefined") {
  const _ResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => callback(entries, observer));
      });
    }
  };
}

// Loads the Clarity project belonging to this org's portal hostname.
initClarity();

ReactDOM.render(<App />, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals)
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
